import Swiper from "swiper";
import { Pagination } from 'swiper/modules';
import "swiper/css/bundle";

(() => {
  const swipers = document.querySelectorAll('.js-swiper');


  if (swipers.length === 0) return;

  let swiperInstances = [];

  function initSwipers() {
    swipers.forEach((swiperElement, index) => {
      // Skip if already initialized
      if (swiperInstances[index]) return;

      const swiperInstance = new Swiper(swiperElement, {
        spaceBetween: swiperElement.dataset.spaceBetween || "32",
        slidesPerView: swiperElement.dataset.slidesPerViewMobile || "1.5",
        centeredSlidesBounds: swiperElement.dataset.centeredSlidesBounds === 'true',
        centeredSlides: swiperElement.dataset.centeredSlides === 'true',
        initialSlide: swiperElement.dataset.initialSlide || "2",
        breakpoints: {
          768: {
            slidesPerView: swiperElement.dataset.slidesPerView || "auto",
          }
        },
        pagination: {
          el: swiperElement.querySelector('.swiper-pagination'),
          clickable: true,
        },
        modules: [
          Pagination
        ],
      });

      swiperInstances[index] = swiperInstance;
    });
  }

  // Initialize on load
  initSwipers();

})();
